import React from 'react'
import ReactGA from 'react-ga'
import {withRouter} from 'react-router'

import config from 'lib/config'

const enableTracking = !!config.GOOGLE_ANALYTICS_KEY
if (enableTracking) {
  ReactGA.initialize(config.GOOGLE_ANALYTICS_KEY)
  ReactGA.plugin.require('ecommerce')
}

class GoogleAnalytics extends React.Component {
  componentDidMount() {
    this.sendPageView(this.props.location)
    this.props.history.listen(this.sendPageView)
  }

  sendPageView(location) {
    if (enableTracking) {
      const page = `${location.pathname}${location.search}`
      ReactGA.set({page})
      ReactGA.pageview(page)
    }
  }

  render() {
    return this.props.children
  }
}

const wrappedGoogleAnalytics = withRouter(GoogleAnalytics)

export {wrappedGoogleAnalytics as GoogleAnalytics}

export default ReactGA
